import { h } from 'preact'
import { i18n } from 'i18n/i18n'
import { formatNumberTrimZeros, formatNumberWithSep } from 'utils/format-number'
import type { Calculation, ExchangeDirection } from 'models/exchange-transfer-calculate'
import { CalculatorCtaButton } from 'common-modules/calculator-cta-button'

interface CalculatorFooterProps {
  exchangeData: Calculation
  direction: ExchangeDirection
  counterCurrency: string
  discountRate?: number
  ctaHref: string
  openCtaInNewTab?: boolean
}

export function CalculatorFooter({
  exchangeData,
  direction,
  counterCurrency,
  discountRate,
  ctaHref,
  openCtaInNewTab = false,
}: CalculatorFooterProps) {
  const calculationResultWithFee =
    (direction === 'forward' ? Number(exchangeData.bought_amount) : Number(exchangeData.sold_amount)) || 0
  const feeAmount = Number(exchangeData.fee_amount) || 0
  const feePercent = Number(exchangeData.fee_percent) || 0
  const isPromotionActive = discountRate !== 0

  const commissionLabel = String(
    i18n(
      isPromotionActive ? 'widgetCalculator.commission' : 'calculator.commissionWT',
      isPromotionActive ? { commission: formatNumberTrimZeros(feePercent) } : undefined,
    ),
  )
  const amountLabel = String(
    i18n(
      isPromotionActive
        ? `widgetCalculator.exchangeAmount${direction === 'forward' ? 'BuyLabel' : 'SellLabel'}`
        : 'calculator.amountText',
    ),
  )

  return (
    <div className="exchange-calculator__footer">
      <div className="exchange-calculator__summary">
        <p className="exchange-calculator__actual-rate-fee">
          <span className="exchange-calculator__actual-rate-fee-text">{commissionLabel}:</span>
          <b className="exchange-calculator__actual-rate-fee-value">
            &nbsp;{formatNumberWithSep(feeAmount, 2)}&nbsp;{counterCurrency}
          </b>
        </p>
        <p className="exchange-calculator__exchange-amount">
          <span className="exchange-calculator__exchange-amount-text">{amountLabel}:</span>
          <b className="exchange-calculator__exchange-amount-value">
            &nbsp;{formatNumberWithSep(calculationResultWithFee, 2)}&nbsp;{counterCurrency}
          </b>
        </p>
      </div>

      <CalculatorCtaButton
        href={ctaHref}
        openInNewTab={openCtaInNewTab}
      />
    </div>
  )
}
